// icons from https://thenounproject.com/search/icons/?q=

import various from '../assets/various.png';
import arms from '../assets/arms.png';
import biceps from '../assets/biceps.png';
import triceps from '../assets/triceps.png';
import shoulder from '../assets/shoulder.png';
import back from '../assets/back.png';
import traps from '../assets/traps.png';
import chest from '../assets/chest.png';
import legs from '../assets/legs.png';
import quads from '../assets/quads.png';
import glutes from '../assets/glutes.png';
import abs from '../assets/abs.png';
import lowback from '../assets/lowback.png';
import forearms from '../assets/forearms.png';
import calves from '../assets/calves.png';
import hamstrings from '../assets/hamstrings.png';

import dumbbells from '../assets/dumbbells.png';
import kettlebell from '../assets/kettlebell.png';
import barbell from '../assets/barbell.png';
import ball from '../assets/ball.png';
import fixedbar from '../assets/fixedbar.png';
import dumbbellbar from '../assets/dumbbellbar.png';
import weightplates from '../assets/weightplates.png';
import fixedbench from '../assets/fixedbench.png';
import adjustablebench from '../assets/adjustablebench.png';
import pullupbar from '../assets/pullupbar.png';
import station from '../assets/station.png';
import bands from '../assets/bands.png';
import trainingbands from '../assets/trainingbands.png';
import mat from '../assets/mat.png';

export const equipmentsTemplate = [
  'Somente o Corpo',
  'Academia Completa',
  'Halteres',
  'Kettlebell',
  'Barra de Supino',
  'Bola de Peso',
  'Barra de Peso Fixo',
  'Barra de Anilhas Ajustáveis',
  'Anilhas de Peso',
  'Banco de Musculação Fixo',
  'Banco de Musculação Ajustável',
  'Barra de Porta',
  'Estação de Musculação',
  'Faixas de Resistência',
  'Elásticos de Treinamento',
  'Tapete de Exercícios',
];

export const equipmentsTemplateEn = [
  'Bodyweight Only',
  'Whole Gym',
  'Dumbbells',
  'Kettlebell',
  'Barbell',
  'Weight Ball',
  'Fixed Weight Bar',
  'Adjustable Dumbbell Bar',
  'Weight Plates',
  'Fixed Weight Bench',
  'Adjustable Weight Bench',
  'Door Bar',
  'Strength Training Station',
  'Resistance Bands',
  'Training Bands',
  'Exercise Mat',
];

export const muscularGroupsTemplate = [
  'Variados',
  'Braços',
  'Bíceps',
  'Tríceps',
  'Antebraços',
  'Ombros',
  'Costas',
  'Trapézio',
  'Lombar',
  'Peito',
  'Pernas',
  'Quadríceps',
  'Posterior de Coxa',
  'Glúteos',
  'Panturrilhas',
  'Abdominais',
];

export const muscularGroupsTemplateEn = [
  'Various',
  'Arms',
  'Biceps',
  'Triceps',
  'Forearms',
  'Shoulders',
  'Back',
  'Traps',
  'Lower Back',
  'Chest',
  'Legs',
  'Quads',
  'Hamstrings',
  'Glutes',
  'Calves',
  'Abdominals',
];

export const muscularGroupIcons = [
  various,
  arms,
  biceps,
  triceps,
  forearms,
  shoulder,
  back,
  traps,
  lowback,
  chest,
  legs,
  quads,
  hamstrings,
  glutes,
  calves,
  abs,
];

export const equipmentIcons = [
  various,
  station,
  dumbbells,
  kettlebell,
  barbell,
  ball,
  fixedbar,
  dumbbellbar,
  weightplates,
  fixedbench,
  adjustablebench,
  pullupbar,
  station,
  bands,
  trainingbands,
  mat,
];

export const trainingNames = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

export const foodExclusionCategories = [
  {
    name: 'Proteínas',
    foods: ['Frango', 'Carne Bovina', 'Carne Suína', 'Peixe', 'Camarão', 'Atum', 'Sardinha', 'Peru', 'Pato', 'Cordeiro', 'Coelho', 'Vísceras'],
  },
  {
    name: 'Laticínios',
    foods: ['Leite', 'Queijo', 'Iogurte', 'Manteiga', 'Requeijão', 'Creme de Leite', 'Whey Protein'],
  },
  {
    name: 'Ovos',
    foods: ['Ovos'],
  },
  {
    name: 'Grãos e Cereais',
    foods: ['Arroz Branco', 'Arroz Integral', 'Aveia', 'Pão', 'Macarrão', 'Quinoa', 'Granola', 'Tapioca', 'Cuscuz', 'Milho', 'Centeio', 'Cevada'],
  },
  {
    name: 'Leguminosas',
    foods: ['Feijão', 'Lentilha', 'Grão-de-bico', 'Ervilha', 'Soja'],
  },
  {
    name: 'Verduras e Legumes',
    foods: ['Brócolis', 'Couve-flor', 'Espinafre', 'Alface', 'Tomate', 'Cenoura', 'Batata', 'Batata-doce', 'Mandioca', 'Inhame', 'Abobrinha', 'Berinjela', 'Pepino', 'Beterraba', 'Abóbora', 'Chuchu', 'Quiabo', 'Vagem', 'Repolho', 'Couve', 'Cebola'],
  },
  {
    name: 'Frutas',
    foods: ['Banana', 'Maçã', 'Laranja', 'Morango', 'Uva', 'Manga', 'Mamão', 'Abacaxi', 'Melancia', 'Melão', 'Kiwi', 'Pera', 'Abacate', 'Limão', 'Maracujá', 'Goiaba', 'Ameixa', 'Coco'],
  },
  {
    name: 'Oleaginosas e Sementes',
    foods: ['Amendoim', 'Castanha-de-caju', 'Castanha-do-pará', 'Nozes', 'Amêndoas', 'Chia', 'Linhaça', 'Gergelim', 'Semente de Girassol', 'Pistache'],
  },
  {
    name: 'Óleos e Gorduras',
    foods: ['Azeite de Oliva', 'Óleo de Coco', 'Óleo de Canola', 'Banha', 'Margarina'],
  },
  {
    name: 'Açúcares e Adoçantes',
    foods: ['Açúcar Refinado', 'Açúcar Mascavo', 'Mel', 'Adoçante', 'Xarope de Milho'],
  },
  {
    name: 'Processados',
    foods: ['Embutidos', 'Salsicha', 'Presunto', 'Bacon', 'Nuggets', 'Enlatados', 'Salgadinhos', 'Biscoitos', 'Refrigerante', 'Suco Industrializado'],
  },
  {
    name: 'Outros',
    foods: ['Glúten', 'Cafeína', 'Álcool', 'Suplementos', 'Frituras', 'Alimentos Ultraprocessados'],
  },
];

export const foodExclusionCategoriesEn = [
  {
    name: 'Proteins',
    foods: ['Chicken', 'Beef', 'Pork', 'Fish', 'Shrimp', 'Tuna', 'Sardines', 'Turkey', 'Duck', 'Lamb', 'Rabbit', 'Organ Meats'],
  },
  {
    name: 'Dairy',
    foods: ['Milk', 'Cheese', 'Yogurt', 'Butter', 'Cream Cheese', 'Heavy Cream', 'Whey Protein'],
  },
  {
    name: 'Eggs',
    foods: ['Eggs'],
  },
  {
    name: 'Grains & Cereals',
    foods: ['White Rice', 'Brown Rice', 'Oats', 'Bread', 'Pasta', 'Quinoa', 'Granola', 'Tapioca', 'Couscous', 'Corn', 'Rye', 'Barley'],
  },
  {
    name: 'Legumes',
    foods: ['Beans', 'Lentils', 'Chickpeas', 'Peas', 'Soy'],
  },
  {
    name: 'Vegetables',
    foods: ['Broccoli', 'Cauliflower', 'Spinach', 'Lettuce', 'Tomato', 'Carrot', 'Potato', 'Sweet Potato', 'Cassava', 'Yam', 'Zucchini', 'Eggplant', 'Cucumber', 'Beet', 'Pumpkin', 'Chayote', 'Okra', 'Green Beans', 'Cabbage', 'Kale', 'Onion'],
  },
  {
    name: 'Fruits',
    foods: ['Banana', 'Apple', 'Orange', 'Strawberry', 'Grape', 'Mango', 'Papaya', 'Pineapple', 'Watermelon', 'Melon', 'Kiwi', 'Pear', 'Avocado', 'Lemon', 'Passion Fruit', 'Guava', 'Plum', 'Coconut'],
  },
  {
    name: 'Nuts & Seeds',
    foods: ['Peanuts', 'Cashews', 'Brazil Nuts', 'Walnuts', 'Almonds', 'Chia Seeds', 'Flaxseed', 'Sesame', 'Sunflower Seeds', 'Pistachios'],
  },
  {
    name: 'Oils & Fats',
    foods: ['Olive Oil', 'Coconut Oil', 'Canola Oil', 'Lard', 'Margarine'],
  },
  {
    name: 'Sweeteners & Sugars',
    foods: ['Refined Sugar', 'Brown Sugar', 'Honey', 'Artificial Sweetener', 'Corn Syrup'],
  },
  {
    name: 'Processed Foods',
    foods: ['Processed Meats', 'Sausage', 'Ham', 'Bacon', 'Nuggets', 'Canned Foods', 'Chips', 'Cookies', 'Soda', 'Processed Juice'],
  },
  {
    name: 'Others',
    foods: ['Gluten', 'Caffeine', 'Alcohol', 'Supplements', 'Fried Foods', 'Ultra-Processed Foods'],
  },
];

export const foodExclusions = foodExclusionCategories.flatMap((c) => c.foods);
export const foodExclusionsEn = foodExclusionCategoriesEn.flatMap((c) => c.foods);

export const workoutSplits = [
  {
    nameEn: 'Full Body',
    namePt: 'Corpo Inteiro',
    workoutsEn: [
      {
        label: 'Full Body A',
        muscles:
          'all major muscle groups: chest, back, shoulders, biceps, triceps, core, quadriceps, hamstrings, glutes and calves — strength focus with heavy compound movements',
      },
      {
        label: 'Full Body B',
        muscles:
          'all major muscle groups: chest, back, shoulders, biceps, triceps, core, quadriceps, hamstrings, glutes and calves — hypertrophy focus with varied exercises different from Full Body A',
      },
      {
        label: 'Full Body C',
        muscles:
          'all major muscle groups: chest, back, shoulders, biceps, triceps, core, quadriceps, hamstrings, glutes and calves — functional and athletic focus with different exercises from Full Body A and B',
      },
    ],
    workoutsPt: [
      {
        label: 'Corpo Inteiro A',
        muscles:
          'todos os grupos musculares principais: peito, costas, ombros, bíceps, tríceps, core, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em força com movimentos compostos pesados',
      },
      {
        label: 'Corpo Inteiro B',
        muscles:
          'todos os grupos musculares principais: peito, costas, ombros, bíceps, tríceps, core, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em hipertrofia com exercícios variados diferentes do Corpo Inteiro A',
      },
      {
        label: 'Corpo Inteiro C',
        muscles:
          'todos os grupos musculares principais: peito, costas, ombros, bíceps, tríceps, core, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco funcional e atlético com exercícios diferentes do Corpo Inteiro A e B',
      },
    ],
  },
  {
    nameEn: 'Full Body 5x a Week',
    namePt: 'Corpo Inteiro 5x na Semana',
    workoutsEn: [
      {
        label: 'Full Body A',
        muscles:
          'all major muscle groups: chest, back, shoulders, biceps, triceps, core, quadriceps, hamstrings, glutes and calves — strength focus built around squats, bench press and rows',
      },
      {
        label: 'Full Body B',
        muscles:
          'all major muscle groups: chest, back, shoulders, biceps, triceps, core, quadriceps, hamstrings, glutes and calves — hypertrophy focus built around a hip hinge (deadlift or hip thrust), overhead press and pull-ups or pulldowns, different exercises from Full Body A',
      },
      {
        label: 'Full Body C',
        muscles:
          'all major muscle groups: chest, back, shoulders, biceps, triceps, core, quadriceps, hamstrings, glutes and calves — unilateral and athletic focus: lunges or split squats, single-arm presses and rows, and core work, different exercises from Full Body A and B',
      },
      {
        label: 'Full Body D',
        muscles:
          'all major muscle groups: chest, back, shoulders, biceps, triceps, core, quadriceps, hamstrings, glutes and calves — hypertrophy focus with extra work for shoulders, biceps, triceps and calves, different exercises from Full Body A, B and C',
      },
      {
        label: 'Full Body E',
        muscles:
          'all major muscle groups: chest, back, shoulders, biceps, triceps, core, quadriceps, hamstrings, glutes and calves — posterior chain and core focus: hamstrings, glutes and back first, then chest and quadriceps, different exercises from Full Body A to D',
      },
    ],
    workoutsPt: [
      {
        label: 'Corpo Inteiro A',
        muscles:
          'todos os grupos musculares principais: peito, costas, ombros, bíceps, tríceps, core, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em força com agachamento, supino e remada como base',
      },
      {
        label: 'Corpo Inteiro B',
        muscles:
          'todos os grupos musculares principais: peito, costas, ombros, bíceps, tríceps, core, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em hipertrofia com levantamento terra ou elevação pélvica, desenvolvimento e barra fixa ou puxada como base, exercícios diferentes do Corpo Inteiro A',
      },
      {
        label: 'Corpo Inteiro C',
        muscles:
          'todos os grupos musculares principais: peito, costas, ombros, bíceps, tríceps, core, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco unilateral e atlético: avanço ou agachamento búlgaro, supino e remada com um braço e trabalho de core, exercícios diferentes do Corpo Inteiro A e B',
      },
      {
        label: 'Corpo Inteiro D',
        muscles:
          'todos os grupos musculares principais: peito, costas, ombros, bíceps, tríceps, core, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em hipertrofia com volume extra para ombros, bíceps, tríceps e panturrilhas, exercícios diferentes do Corpo Inteiro A, B e C',
      },
      {
        label: 'Corpo Inteiro E',
        muscles:
          'todos os grupos musculares principais: peito, costas, ombros, bíceps, tríceps, core, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em cadeia posterior e core: posteriores da coxa, glúteos e costas primeiro, depois peito e quadríceps, exercícios diferentes do Corpo Inteiro A a D',
      },
    ],
  },
  {
    nameEn: 'Upper / Lower',
    namePt: 'Superior / Inferior',
    workoutsEn: [
      {
        label: 'Upper A',
        muscles:
          'chest, back, shoulders, biceps and triceps — strength focus with heavy compound movements',
      },
      {
        label: 'Lower A',
        muscles:
          'quadriceps, hamstrings, glutes and calves — strength focus with heavy compound movements',
      },
      {
        label: 'Upper B',
        muscles:
          'chest, back, shoulders, biceps and triceps — hypertrophy focus with varied exercises different from Upper A',
      },
      {
        label: 'Lower B',
        muscles:
          'quadriceps, hamstrings, glutes and calves — hypertrophy focus with varied exercises different from Lower A',
      },
    ],
    workoutsPt: [
      {
        label: 'Superior A',
        muscles:
          'peito, costas, ombros, bíceps e tríceps — foco em força com movimentos compostos pesados',
      },
      {
        label: 'Inferior A',
        muscles:
          'quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em força com movimentos compostos pesados',
      },
      {
        label: 'Superior B',
        muscles:
          'peito, costas, ombros, bíceps e tríceps — foco em hipertrofia com exercícios variados diferentes do Superior A',
      },
      {
        label: 'Inferior B',
        muscles:
          'quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em hipertrofia com exercícios variados diferentes do Inferior A',
      },
    ],
  },
  {
    nameEn: 'Bro Split',
    namePt: 'Bro Split',
    workoutsEn: [
      {
        label: 'Chest Day',
        muscles: 'chest and upper chest, with some front deltoid involvement',
      },
      { label: 'Back Day', muscles: 'back, traps and rear deltoids' },
      {
        label: 'Shoulders Day',
        muscles: 'all three deltoid heads: front, lateral and rear',
      },
      { label: 'Arms Day', muscles: 'biceps, triceps and forearms' },
      { label: 'Legs Day', muscles: 'quadriceps, hamstrings, glutes and calves' },
    ],
    workoutsPt: [
      {
        label: 'Dia de Peito',
        muscles: 'peito e peito superior, com algum envolvimento do deltóide frontal',
      },
      { label: 'Dia de Costas', muscles: 'costas, trapézio e deltóides posteriores' },
      {
        label: 'Dia de Ombros',
        muscles: 'todas as três cabeças do deltóide: frontal, lateral e posterior',
      },
      { label: 'Dia de Braços', muscles: 'bíceps, tríceps e antebraços' },
      {
        label: 'Dia de Pernas',
        muscles: 'quadríceps, posteriores da coxa, glúteos e panturrilhas',
      },
    ],
  },
  {
    nameEn: 'Torso / Limbs',
    namePt: 'Tronco / Membros',
    workoutsEn: [
      {
        label: 'Torso A',
        muscles: 'chest, back, shoulders and core — strength focus with heavy compound movements',
      },
      {
        label: 'Limbs A',
        muscles:
          'biceps, triceps, forearms, quadriceps, hamstrings, glutes and calves — strength focus with compound movements',
      },
      {
        label: 'Torso B',
        muscles: 'chest, back, shoulders and core — hypertrophy focus with varied exercises different from Torso A',
      },
      {
        label: 'Limbs B',
        muscles:
          'biceps, triceps, forearms, quadriceps, hamstrings, glutes and calves — hypertrophy focus with varied exercises different from Limbs A',
      },
    ],
    workoutsPt: [
      {
        label: 'Tronco A',
        muscles: 'peito, costas, ombros e core — foco em força com movimentos compostos pesados',
      },
      {
        label: 'Membros A',
        muscles:
          'bíceps, tríceps, antebraços, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em força com movimentos compostos',
      },
      {
        label: 'Tronco B',
        muscles: 'peito, costas, ombros e core — foco em hipertrofia com exercícios variados diferentes do Tronco A',
      },
      {
        label: 'Membros B',
        muscles:
          'bíceps, tríceps, antebraços, quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em hipertrofia com exercícios variados diferentes do Membros A',
      },
    ],
  },
  {
    nameEn: 'Push / Pull / Legs',
    namePt: 'Push / Pull / Legs',
    workoutsEn: [
      { label: 'Push', muscles: 'chest, front shoulders and triceps' },
      { label: 'Pull', muscles: 'back, rear shoulders and biceps' },
      { label: 'Legs', muscles: 'quadriceps, hamstrings, glutes and calves' },
    ],
    workoutsPt: [
      { label: 'Push', muscles: 'peito, deltóides frontais e tríceps' },
      { label: 'Pull', muscles: 'costas, deltóides posteriores e bíceps' },
      {
        label: 'Legs',
        muscles: 'quadríceps, posteriores da coxa, glúteos e panturrilhas',
      },
    ],
  },
  {
    nameEn: 'Push / Pull / Legs / Upper',
    namePt: 'Push / Pull / Legs / Superior',
    workoutsEn: [
      {
        label: 'Push',
        muscles:
          'chest, front shoulders and triceps — strength focus with heavy compounds',
      },
      {
        label: 'Pull',
        muscles:
          'back, rear shoulders and biceps — strength focus with heavy compounds',
      },
      {
        label: 'Legs',
        muscles:
          'quadriceps, hamstrings, glutes and calves — strength focus with heavy compounds',
      },
      {
        label: 'Upper',
        muscles:
          'chest, back, shoulders, biceps and triceps — hypertrophy focus, different exercises from Push and Pull',
      },
    ],
    workoutsPt: [
      {
        label: 'Push',
        muscles:
          'peito, deltoides frontais e tríceps — foco em força com compostos pesados',
      },
      {
        label: 'Pull',
        muscles:
          'costas, deltoides posteriores e bíceps — foco em força com compostos pesados',
      },
      {
        label: 'Legs',
        muscles:
          'quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em força com compostos pesados',
      },
      {
        label: 'Superior',
        muscles:
          'peito, costas, ombros, bíceps e tríceps — foco em hipertrofia, exercícios diferentes do Push e do Pull',
      },
    ],
  },
  {
    nameEn: 'Push / Pull / Legs / Upper / Lower',
    namePt: 'Push / Pull / Legs / Superior / Inferior',
    workoutsEn: [
      {
        label: 'Push',
        muscles:
          'chest, front shoulders and triceps — hypertrophy focus',
      },
      {
        label: 'Pull',
        muscles:
          'back, rear shoulders and biceps — hypertrophy focus',
      },
      {
        label: 'Legs',
        muscles:
          'quadriceps, hamstrings, glutes and calves — hypertrophy focus',
      },
      {
        label: 'Upper',
        muscles:
          'chest, back, shoulders, biceps and triceps — strength focus with heavy compound movements, different exercises from Push and Pull',
      },
      {
        label: 'Lower',
        muscles:
          'quadriceps, hamstrings, glutes and calves — strength focus with heavy compound movements, different exercises from Legs',
      },
    ],
    workoutsPt: [
      {
        label: 'Push',
        muscles:
          'peito, deltoides frontais e tríceps — foco em hipertrofia',
      },
      {
        label: 'Pull',
        muscles:
          'costas, deltoides posteriores e bíceps — foco em hipertrofia',
      },
      {
        label: 'Legs',
        muscles:
          'quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em hipertrofia',
      },
      {
        label: 'Superior',
        muscles:
          'peito, costas, ombros, bíceps e tríceps — foco em força com movimentos compostos pesados, exercícios diferentes do Push e do Pull',
      },
      {
        label: 'Inferior',
        muscles:
          'quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em força com movimentos compostos pesados, exercícios diferentes do Legs',
      },
    ],
  },
  {
    nameEn: 'Push / Pull / Legs (x2)',
    namePt: 'Push / Pull / Legs (x2)',
    workoutsEn: [
      {
        label: 'Push A',
        muscles: 'chest, front shoulders and triceps — strength focus with heavy compounds',
      },
      {
        label: 'Pull A',
        muscles: 'back, rear shoulders and biceps — strength focus with heavy compounds',
      },
      {
        label: 'Legs A',
        muscles: 'quadriceps, hamstrings, glutes and calves — strength focus',
      },
      {
        label: 'Push B',
        muscles:
          'chest, front shoulders and triceps — hypertrophy focus, different exercises from Push A',
      },
      {
        label: 'Pull B',
        muscles:
          'back, rear shoulders and biceps — hypertrophy focus, different exercises from Pull A',
      },
      {
        label: 'Legs B',
        muscles:
          'quadriceps, hamstrings, glutes and calves — hypertrophy focus, different exercises from Legs A',
      },
    ],
    workoutsPt: [
      {
        label: 'Push A',
        muscles: 'peito, deltóides frontais e tríceps — foco em força com compostos pesados',
      },
      {
        label: 'Pull A',
        muscles: 'costas, deltóides posteriores e bíceps — foco em força com compostos pesados',
      },
      {
        label: 'Legs A',
        muscles: 'quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em força',
      },
      {
        label: 'Push B',
        muscles:
          'peito, deltóides frontais e tríceps — foco em hipertrofia, exercícios diferentes do Push A',
      },
      {
        label: 'Pull B',
        muscles:
          'costas, deltóides posteriores e bíceps — foco em hipertrofia, exercícios diferentes do Pull A',
      },
      {
        label: 'Legs B',
        muscles:
          'quadríceps, posteriores da coxa, glúteos e panturrilhas — foco em hipertrofia, exercícios diferentes do Legs A',
      },
    ],
  },
];

